import { render } from "./ProspectReviewsDetails.vue?vue&type=template&id=6999fb44"
import script from "./ProspectReviewsDetails.vue?vue&type=script&lang=js"
export * from "./ProspectReviewsDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__